import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const stripe = defineConnector({
  identifier: "stripe",
  name: "Stripe",
  tagLine: "Payment processing platform",
  logo,
  protocol: "http",
  tags: ["featured", "data"],
  defaultUrlPattern: () => "https://api\\.stripe\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.apiKey,
      password: "",
    }),
  steps: [
    {
      title: "Get your Stripe API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [Stripe Dashboard](https://dashboard.stripe.com/apikeys) and copy your **Secret key**.\n\nFor testing, you can use a test mode key (starts with `sk_test_`). For production, use a live mode key (starts with `sk_live_`).",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Secret key",
          placeholder: "sk_live_... or sk_test_...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.stripe.com/v1/balance",
  },
});
